// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zNqCD","title":"Info_title__315mu","selects":"Info_selects__1kXWS","requiredAsterisk":"Info_requiredAsterisk__10eob"};